import { Component, Input } from '@angular/core';
import { LocaleAwareBaseComponent } from './../../../common-theme/seo/locale-aware-base.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})

export class ContactUsComponent extends LocaleAwareBaseComponent {
  @Input() component: string;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contact-us/contact-us.component.ts